import script from "./section-4.vue?vue&type=script&setup=true&lang=js"
export * from "./section-4.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__